import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputGroup } from './InputGroup.entity';

export class MutateCustomerGroups<T extends EMode = EMode.entity> {
  /** Alias: structure */
  structure?: InputGroup<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<MutateCustomerGroups> = {
  structure: {
    alias: 'structure',
  },
  __typename: {
    alias: '__typename',
  },
};

export const mutateCustomerGroupsEntityDefinition: EntitiyDefinition<MutateCustomerGroups> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'MutateCustomerGroups',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
